import { merge, of, fromEvent, BehaviorSubject } from 'rxjs';
import { mapTo } from 'rxjs/operators';
import * as i0 from "@angular/core";
var ConnectionService = /** @class */ (function () {
    function ConnectionService() {
        var _this = this;
        this._connection = new BehaviorSubject(true);
        merge(of(navigator.onLine), fromEvent(window, 'online').pipe(mapTo(true)), fromEvent(window, 'offline').pipe(mapTo(false))).subscribe(function (value) { return _this._connection.next(value); });
    }
    Object.defineProperty(ConnectionService.prototype, "connection", {
        get: function () {
            return this._connection.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConnectionService.prototype, "connection$", {
        get: function () {
            return this._connection.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    ConnectionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ConnectionService_Factory() { return new ConnectionService(); }, token: ConnectionService, providedIn: "root" });
    return ConnectionService;
}());
export { ConnectionService };
